import __vue_component__ from './IconWrapper.vue.js';

var JiraTestSessionIcon = {
  name: 'JiraTestSessionIcon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd"><path d="M7 9.306C7 6.376 9.238 4 12 4c2.761 0 4.999 2.376 4.999 5.306v6.388C16.999 18.624 14.761 21 12 21c-2.762 0-5-2.376-5-5.306V9.306zm1.999 6.388c0 1.758 1.344 3.183 3.001 3.183 1.657 0 3-1.425 3-3.183V9.306c0-1.758-1.343-3.183-3-3.183S8.999 7.548 8.999 9.306v6.388z"/><path d="M4 12.397a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H4zm13 0a1 1 0 0 0 0 1.999h3.001a1 1 0 1 0 0-1.999H17zM7.673 15.74L3.65 17.22a1.003 1.003 0 0 0-.59 1.281.986.986 0 0 0 1.267.597l4.021-1.48a1.002 1.002 0 0 0-.338-1.939.978.978 0 0 0-.338.06zM3.062 8.272a.977.977 0 0 0 .606 1.262l3.97 1.4c.527.187 1.11-.076 1.3-.587a.977.977 0 0 0-.606-1.263l-3.97-1.4a1.042 1.042 0 0 0-.347-.06c-.414 0-.805.248-.953.648zm16.536-.532l-3.916 1.368c-.54.189-.82.763-.622 1.282.197.519.795.786 1.335.597l3.916-1.368c.54-.189.82-.763.622-1.281a1.041 1.041 0 0 0-.979-.658c-.117 0-.238.019-.356.06zm-4.538 8.62a1.031 1.031 0 0 0 .622 1.323l3.916 1.413a1.044 1.044 0 0 0 1.335-.617 1.031 1.031 0 0 0-.622-1.324l-3.916-1.414a1.043 1.043 0 0 0-1.335.618z"/><path d="M8.715 9.397a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6zM8.83 3.33a1 1 0 0 0-.366 1.366l.75 1.3a1 1 0 1 0 1.732-1l-.75-1.3a.998.998 0 0 0-1.367-.366zm5.13.385l-.745 1.289a1.003 1.003 0 1 0 1.739 1.005l.742-1.29a1.006 1.006 0 0 0-.866-1.508 1 1 0 0 0-.87.504z"/></g></svg>'
      }
    });
  }

};

export default JiraTestSessionIcon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/JiraTestSessionIcon.js